RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    views.TimePeriodPickerButton = Marionette.LayoutView.extend({
        template: '#shellTimePeriodPickerButtonTemplate',
        regions: {
            timePeriodPickerContainer: '.time-period-picker-container'
        },
        ui: {
            popovers: '[data-toggle="popover"]'
        },
        events: {
            'click .btn-filter': 'toggleTimePicker'
        },
        behaviors: {
            AttributeBuilder: {}
        },
        onRender: function () {
            const me = this;
            if (me.isDisabled()) {
                me.ui.popovers.popover({
                    html: true,
                    trigger: 'hover',
                    placement: 'auto bottom',
                    container: 'body'
                });
            }
        },
        onDestroy: function () {
            const me = this;
            me.ui.popovers.popover('destroy');
        },
        serializeData: function () {
            const me = this;
            const timePeriod = me.model;
            const forced = {};
            const defaults = {
                description: RivalIQ.state.timePeriods.getDefinitionByType(RivalIQ.enums.timePeriod.type.NOT_AVAILABLE).description
            };

            // for custom time periods just show the main period #10270
            if (timePeriod.id === RivalIQ.enums.timePeriod.type.CUSTOM) {
                forced.displayString = RivalIQ.utils.timePeriod.getMainPeriodDisplayString(timePeriod);
            }

            if (me.getOption('displayStringOverride')) {
                forced.displayString = me.getOption('displayStringOverride');
            }

            if (me.getOption('descriptionOverride')) {
                forced.description = me.getOption('descriptionOverride');
            }

            return _.defaults(forced, timePeriod, defaults);
        },
        templateHelpers: function () {
            const me = this;
            return {
                disabled: me.isDisabled()
            };
        },
        toggleTimePicker: function () {
            const me = this;

            if (me.timePeriodPickerContainer.hasView()) {
                me.hideTimePeriodPicker();
            } else {
                me.showTimePeriodPicker();
            }
        },
        showTimePeriodPicker: function () {
            const me = this;
            const timePeriod = RivalIQ.state.view.get('timePeriod');

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.DatePickerV2Opened);
            me.timePeriodPickerContainer.show(new views.TimePeriodPicker({
                model: new Backbone.Model({
                    timePeriod: RivalIQ.utils.timePeriod.convertTimePeriod(timePeriod)
                }),
                dateRangeRestrictions: me.getOption('dateRangeRestrictions'),
                notateMissingData: me.options.notateMissingData
            }));
        },
        hideTimePeriodPicker: function () {
            const me = this;

            me.timePeriodPickerContainer.empty();
        },
        onTimePeriodChanged: function () {
            const me = this;
            me.model = RivalIQ.state.view.get('timePeriod');
            me.render();
        },
        isDisabled: function () {
            const me = this;
            return RivalIQ.utils.timePeriod.isDisabled(me.model);
        },
        initialize: function () {
            const me = this;
            me.listenTo(RivalIQ.state.view, 'change:timePeriod', me.onTimePeriodChanged);
            me.listenTo(RivalIQ.state.landscape, 'change:timezone', me.onTimePeriodChanged);
        }
    });

}, window.moment);
